module.exports = __webpack_public_path__ + "img/icon-warning.739f0681.svg";